"use client";
import React, { useEffect } from 'react'; // <-- Added useEffect import
import Header from '../Header';
import Breadcrumb from './Breadcrumb';
import ProductInfo from './ProductInfo';
import ProductSpecs from './ProductSpecs';
import ReviewsSection from './ReviewsSection';
import Footer from '../Footer';

function ProductDetail() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex flex-col justify-center items-center mt-6 w-[80%] max-md:max-w-full mx-auto">
        <div className="w-full">
          <Breadcrumb />
        </div>

        <div className="w-full">
          <ProductInfo />
        </div>

        <div className="w-full">
          <ProductSpecs />
        </div>

        <div className="w-full">
          <ReviewsSection />
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ProductDetail;
